import { useUserStore } from '../stores/user';
import { useLoginStore } from '../stores/login';
import { usePublicStore } from '../stores/public';
import { useDoorStore } from '@/stores/door';
import { playTextVoice } from '../utils/voice';
import { sendLightCommand, getLightPlugin, LightCommand } from '@/utils/lightUtils';
import { addGlobalLightTask } from '../hooks/useLightManagement/useLightTaskQueue';
// #ifndef APP
import mqtt from 'mqtt';
import { jumpRePages } from '@/utils/public';
// #endif
const prefix = 'billiard';
let mq = null;
let mqttPlugin = null;
const topic_all = {
    shop: '',
    company: `${prefix}/company/allshops`,
    person: `${prefix}/shop/user/`
};
// #ifdef APP
mqttPlugin = uni.requireNativePlugin('uni-mqtt-plugin');
// #endif

const connect_mqtt = () => {
    return new Promise((resolve) => {
        const mqttInfo = useUserStore().mqttInfo;
        const host = mqttInfo.host.replace('wss', 'tcp') + ':1883';
        console.log(host);
        mqttPlugin.connect(
            {
                serverUri: host, // 例如 tcp://broker.emqx.io:1883
                clientId: mqttInfo.client_id, // 客户端ID，必须唯一
                username: mqttInfo.username,
                password: mqttInfo.password,
                timeout: 3000, // 连接超时时间，毫秒
                keepAlive: 5, // 心跳间隔，秒
                cleanSession: false, // 是否清除会话,
                sessionExpiryInterval: 600 //缓存时长
            },
            (info) => {
                console.log(info);
                switch (info.type) {
                    case 'onConnectSuccess':
                        resolve(true);
                        // subscribe_with_shop();
                        subscribe_with_user();
                        break;
                    case 'onConnectFailed':
                        uni.$emit('showToast', {
                            title: '信息渠道连接失败',
                            type: 'none',
                            duration: 1000
                        });
                        jumpRePages('/pages/login');
                        break;
                    case 'onMessageReceived': {
                        const { topic, message } = info.data;
                        if (topic === topic_all.company) return company_message(message);

                        // shop topic
                        if (topic === topic_all.shop) return shop_message(message);

                        // person topic
                        if (topic === topic_all.person) return person_message(message);
                        break;
                    }
                    case 'onSubscribeSuccess':
                        break;
                }
            }
        );
    });
};
export const init_mqtt = () => {
    if (mqttPlugin) {
        return connect_mqtt();
    }
    try {
        if (mq) {
            mq.end();
            mq = null;
        }
        return new Promise((reject) => {
            const mqttInfo = useUserStore().mqttInfo;
            if (!mqttInfo?.host) return;
            const host = mqttInfo.host;
            mq = mqtt.connect(`${host}/mqtt`, {
                username: mqttInfo.username,
                password: mqttInfo.password,
                port: mqttInfo.port,
                clientId: mqttInfo.client_id,
                protocolVersion: 5,
                properties: {
                    sessionExpiryInterval: 600 // 设置会话过期时间
                },
                keepalive: 60,
                qos: 2, // 消息服务质量等级
                clean: false // 断线重连后订阅主题不丢失
            });

            mq.on('connect', () => {
                console.log('connect');
                // subscribe_with_shop();
                subscribe_with_user();
                reject(true);
            });
            mq.on('message', (topic, message) => {
                console.log('-----------------------');
                console.log('message:', topic, message);
                console.log('-----------------------');

                // company topic
                if (topic === topic_all.company) return company_message(message);

                // shop topic
                if (topic === topic_all.shop) return shop_message(message);

                // person topic
                if (topic === topic_all.person) return person_message(message);
            });

            mq.on('close', () => {
                console.log('mqtt链接关闭');
            });
            mq.on('error', () => {
                console.log('mqtt链接错误');
            });
        });
    } catch (error) {
        console.log('mqtt链接异常', error);
    }
};
export const subscribe_with_user = async () => {
    if (mqttPlugin) {
        if (!mqttPlugin.isConnected()) {
            await init_mqtt();
        }
    } else {
        if (!mq) {
            console.log('订阅用户消息');
            await init_mqtt();
        }
    }

    if (topic_all.person) {
        mq.unsubscribe(topic_all.person);
    }
    const userInfo = useUserStore().userInfo;
    const userId = userInfo?.user_id;
    console.log('订阅用户ID', userId);
    if (userId) {
        topic_all.person = `${prefix}/shop/user/${userId}`;
        console.log(topic_all.person);
        console.log('订阅的消息', topic_all.person);
        mq.subscribe(topic_all.person, { qos: 2 }); //员工注册订阅
    }
};
export const subscribe_with_shop = async () => {
    if (mqttPlugin) {
        if (!mqttPlugin.isConnected()) {
            await init_mqtt();
        }
    } else {
        if (!mq) {
            console.log('订阅店铺消息');
            await init_mqtt();
        }
    }

    // un_subscribe();
    const currentShopInfo = useLoginStore().currentShopInfo;
    const config = usePublicStore().config;
    const shopId = currentShopInfo?.id;
    console.log('订阅的店铺Id', shopId);
    if (config?.hid && shopId) {
        topic_all.shop = `${prefix}/shop/audit/${config.hid}/${shopId}`;
        console.log('订阅的消息', topic_all.shop);
        if (mqttPlugin) {
            mqttPlugin.subscribe(topic_all.shop, 2);
        } else {
            mq.subscribe(topic_all.shop, { qos: 2 });
        }
    }

    if (topic_all.company) {
        if (mqttPlugin) {
            console.log('订阅的消息', topic_all.company);
            mqttPlugin.subscribe(topic_all.company, 2);
        } else {
            console.log('订阅的消息', topic_all.company);
            mq.subscribe(topic_all.company, { qos: 2 });
        }
    }
};
export const exquite_mqtt = () => {
    try {
        console.log('执行断开mqtt连接');
        if (mqttPlugin) {
            if (mqttPlugin.isConnected()) {
                mqttPlugin.disconnect();
            }
        } else {
            if (mq) {
                un_subscribe();
                mq.end();
                mq = null;
            }
        }
    } catch (error) {
        console.log(error);
    }
};
export const un_subscribe = () => {
    if (mqttPlugin) {
        if (mqttPlugin.isConnected()) {
            if (topic_all.shop) {
                mqttPlugin.unsubscribe(topic_all.shop);
            }

            if (topic_all.company) {
                mqttPlugin.unsubscribe(topic_all.company);
            }
        }
    } else {
        if (!mq) return;

        if (topic_all.shop) {
            mq.unsubscribe(topic_all.shop);
        }

        if (topic_all.company) {
            mq.unsubscribe(topic_all.company);
        }
    }
};
const person_message = (message) => {
    const { type, data } = JSON.parse(message);
    console.log('mqtt message:', type, data);
    // 员工登录消息
    console.log('员工登录消息', data);
    if (data.channel == 'cashier') {
        // 登陆时间不一致，强制下线
        // store.dispatch('logout');
        console.log(123);
        const loginStore = useLoginStore();
        loginStore.exitLogin();
        uni.reLaunch({
            url: '/pages/login'
        });
    }
};
const company_message = (message) => {
    const { type, data } = JSON.parse(message);
};
// 业务处理逻辑
const shop_message = (message) => {
    const { type, data } = JSON.parse(message);
    const { config } = usePublicStore().config;
    console.log('mqtt message:', type, data);
    // 教练状态变更不弹出消息弹窗
    // if (type != 'update_coach_status') uni.$emit('showMsgPopup');
    if (!['update_coach_status', 'shop_pay_success', 'light_control', 'bill_windup'].includes(type)) uni.$emit('showMsgPopup');
    if (data?.room_no) {
        data.room_no = String(data.room_no).replace(/-/g, '_');
    }
    switch (type) {
        case 'bill_windup':
            // playTextVoice(`${insertPauseMark(data.room_no)}，账单已结账`);
            useDoorStore().resetDoorFun(data?.bill_id);
            break;
        case 'room_call_self_order':
            if (config.self_open_order) {
                playTextVoice(`${insertPauseMark(data.room_no)}，已有顾客自助开台，请及时查看`);
            } else {
                playTextVoice(`${insertPauseMark(data.room_no)}，申请开台，请及时处理`);
            }
            break;
        case 'room_call_server':
            playTextVoice(`${insertPauseMark(data.room_no)}，呼叫服务`);
            break;
        case 'room_shop_order':
            playTextVoice(`${insertPauseMark(data.room_no)},下单了商品，请及时处理`);
            break;
        case 'room_food_order':
            playTextVoice(`${insertPauseMark(data.room_no)},下单了餐食，请及时处理`);
            break;
        case 'room_coach_order':
            playTextVoice(`${insertPauseMark(data.room_no)},有教练订单，请及时处理`);
            break;
        case 'update_coach_status':
            // 收到教练状态变更，通知刷新教练列表
            // store.commit('triggerRefreshCoachList');
            break;
        case 'room_charge_order':
            playTextVoice(`${insertPauseMark(data.room_no)},开始充电，请注意关注！`);
            break;
        case 'order_charge_complete':
            playTextVoice(`${insertPauseMark(data.room_no)},结束充电，请注意关注！`);
            break;
        case 'shop_pay_success':
            playTextVoice(`收款成功，${data.amount}元`);
            break;
        case 'shop_pay_failed':
            playTextVoice(`收款失败，请核实`);
            break;
        case 'room_advance_timeout_notice':
            uni.$emit('refreshTop');
            playTextVoice(`${insertPauseMark(data.room_no)}${data.content}`);
            break;
        case 'room_advance_renew_notice':
            playTextVoice(`${insertPauseMark(data.room_no)}${data.content}`);
            break;
        case 'room_expend_coach_timeout_notice':
            uni.$emit('refreshTop');
            playTextVoice(`${insertPauseMark(data.room_no)}${data.content}`);
            break;
        //   开关灯消息
        case 'light_control':
            Object.keys(getLightPlugin()).length > 0 && handleLightControlMessage(data);

            break;
        case 'light_command_data':
            Object.keys(getLightPlugin()).length > 0 && LightCommand(data);
            break;
    }
};
const content_enum = {
    room_call_self_order: '自助开台消息',
    room_call_server: '桌台消息',
    room_shop_order: '商城消息',
    room_food_order: '餐食消息',
    room_coach_order: '教练消息',
    room_order_extend: '续订消息',
    room_charge_order: '充电消息',
    order_charge_complete: '充电消息',
    room_advance_timeout_notice: '桌台消息',
    room_advance_renew_notice: '桌台消息',
    room_expend_coach_timeout_notice: '教练消息'
};

/**
 * 处理灯光控制消息
 * @param {Object} data 灯光控制数据
 * @param {String} data.execute_at 灯光关闭时间戳（毫秒时间戳）
 */
const handleLightControlMessage = (data) => {
    console.log('灯光控制消息:', data);
    // if (device_id !== uni.getSystemInfoSync().deviceId) return;

    const { light_status, execute_at = 0, no = '' } = data;
    const cmd = (isOn) => sendLightCommand(isOn, { ...data, code: no, showToast: light_status === 1 });

    light_status === 1 ? cmd(true) : execute_at > 0 ? addGlobalLightTask(data) : cmd(false);
    // 传入灯光状态数据，用于只更新对应桌台而不是刷新整个列表
    uni.$emit('refreshDoorTable', data);
};

function insertPauseMark(str) {
    str = str.toString().toUpperCase();
    // 匹配中文与中文、中文与字母数字之间的位置
    // 处理连续字母数字（纯字母/纯数字）
    str = str.replace(/([0-9])(?=[0-9a-zA-Z])|([a-zA-Z])(?=[0-9a-zA-Z])/g, '$1$2、');
    // 处理中文与字母数字交界
    const info = str.replace(/([\u4E00-\u9FA5])(?=[0-9a-zA-Z])|([0-9a-zA-Z])(?=[\u4E00-\u9FA5])/g, '$1$2、');

    return info.replace('间', '间(jian1)');
}
